import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripePayment from "./stripepayment";
import { useLocation } from "react-router-dom";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const Payment = () => {
  const location = useLocation(); // 👈 Get location state here
  const state = location.state;   // 👈 Pass it to StripePayment

  return (
    <Elements stripe={stripePromise}>
      <StripePayment locationState={state} /> {/* 👈 Pass as prop */}
    </Elements>
  );
};

export default Payment;
